import { render, staticRenderFns } from "./RHDCPage.vue?vue&type=template&id=ffcc30c2&"
import script from "./RHDCPage.vue?vue&type=script&lang=js&"
export * from "./RHDCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports